<template>
    <b-modal :id="id"
        :no-close-on-backdrop="true"
        :title="$t('create_new_category')" 
        ref="innermodal">
        <form ref="form">
            <div v-if="$v.$error" class="alert alert-danger x-error">
                <div class="error" v-if="!$v.model.Name.required">
                    - សូមធ្វើការបញ្ជូលប្រភេទមុខទំនិញ
                </div>
            </div>
            <div class="form-group">
                <input type="text" 
                    class="form-control form-control-sm" 
                    v-model="model.Code" 
                    :placeholder="$t('item_category_code')"/>
            </div>
            <div class="form-group">
                <input type="text" 
                    class="form-control form-control-sm" 
                    v-model.trim="$v.model.Name.$model" 
                    :placeholder="$t('item_category_name')"/>
            </div>
            <div class="form-group">
                <input type="text" 
                    class="form-control form-control-sm" 
                    v-model="model.NameEng" 
                    :placeholder="$t('item_category_name_en')"/>
            </div>
            <div class="form-group">
                <textarea class="form-control form-control-sm" 
                    v-model="model.Description" 
                    :placeholder="$t('item_category_desc')"></textarea>
            </div>
            <div class="row-container">
                <div class="col-img">
                    <img :src="img" 
                        alt="CATEGORY IMG"
                        class="img-thumbnail" 
                        @click="$refs.file.click()"
                        style="cursor: pointer">
                    <input type="file" 
                        ref="file" 
                        hidden  
                        @change="fileChange"/>
                </div>
                <div class="col-form" :class="{ 'form-group-error': $v.model.Name.$error }">
                </div>
            </div>
        </form>
        <div slot="modal-footer">
            <b-btn variant="primary" size="sm" @click="clickSaveHandler">
                <i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}
            </b-btn>
        </div>
    </b-modal>
</template>

<script>
import { required } from 'vuelidate/lib/validators'

export default {
    props: {
        id: { type: String, default: '' },
        value: { type: Object, default: null }
    },
    validations: {
        model: { Name: { required } }
    },
    data() {
        return {
            model: { Code: '', Name: '', NameEng: '', Description: '' },
            img: '/img/avatars/1.jpg'
        }
    },
    methods: {
        async clickSaveHandler() {
            this.$v.$touch()
            if (this.$v.$invalid) return

            const loading = this.$loading.show()
            const formData = new FormData()
            const action = this.model.Id ? 'category/update' : 'category/save'

            formData.append('Code', this.model.Code)
            formData.append('Name', this.model.Name)
            formData.append('NameEng', this.model.NameEng)
            formData.append('Description', this.model.Description)
            if (this.$refs.file.files[0]) formData.append('File', this.$refs.file.files[0])
            if (this.model.Id) formData.append('Id', this.model.Id)

            try {
                const res = await this.$api().post(action, formData)
                if (this.$isValid(res)) {
                    this.$refs.innermodal.hide()
                    this.resetForm()
                    this.$emit('done')
                }
            } finally {
                loading.hide()
            }
        },
        fileChange(e) {
            const file = e.target.files[0]
            if (file) this.img = URL.createObjectURL(file)
        },
        resetForm() {
            this.model = { Code: '', Name: '', NameEng: '', Description: '' }
            this.img = '/img/avatars/1.jpg'
        }
    },
    watch: {
        value: {
            immediate: true,
            handler(newVal) {
                this.model = newVal ? { ...newVal } : {}

                this.img = newVal && newVal.Image
                    ? `${this.$base()}image/categories/${newVal.Image}`
                    : '/img/avatars/1.jpg'
            }
        }
    }
}
</script>

<style scoped>
.row-container {
    display: flex;
    justify-content: space-around;
}

.col-img {
    width: 150px;
    flex-shrink: 0;
}

.col-img img {
    width: 100%;
    height: 108px;
    object-fit: cover;
}

.col-form {
    width: 100%;
    padding: 0 15px;
}
</style>
